export default "__VITE_ASSET__DdpCJXqn__"